import Vue from 'vue';
import App from './vue/App.vue';
import i18n from './tools/i18n'
import router from './router/routes';
import VueAnalytics from 'vue-analytics';
import './scss/index.scss';
import 'font-awesome/css/font-awesome.css';
import VueMeta from 'vue-meta';

Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
  id: 'UA-169326858-1',
  router
});
Vue.use(VueMeta);

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');
